import * as System from "@animech/axiom-format/src/definitions/definition-bindings";
import * as General from "./general-definitions";
import * as Locale from "./locale-definitions";
import * as Product from "./product-definitions";
import * as Property from "./property-definitions";
import * as Rule from "./rule-definitions";
import * as Scene from "./scene-definitions";
import * as Ui from "./ui-definitions";

const Definitions = {
	General,
	Locale,
	Product,
	Property,
	Rule,
	Scene,
	Ui,
	System,
};

export * from "@animech/axiom-format/src/definitions/definition-bindings";
export type {
	CustomPropertyMeta,
	CustomPropertyValueMeta,
} from "./product-definitions";
export type { CustomNode } from "./ui-definitions";
export type { CustomSceneTree } from "./scene-definitions";
export { root } from "./property-definitions";
export type { Root } from "./property-definitions";
export type { RuleApiExtensions } from "./rule-definitions";
export { createRules } from "./rule-definitions";
export type { CustomCameraSettings } from "./type-definitions";
export { isRoundTable, SIDE_INDICES } from "./type-definitions";
export { query } from "./rule-definitions";
export { Definitions };
